<data-table [noCard]="true" [columns]="columns" [newHeader]="true" [dataProvider]="varService" [headerButtons]="headerButtons" (detail)="select($event)"></data-table>
